import { render, staticRenderFns } from "./_Desembolsos.vue?vue&type=template&id=b4515a02&scoped=true&"
import script from "./_Desembolsos.vue?vue&type=script&lang=js&"
export * from "./_Desembolsos.vue?vue&type=script&lang=js&"
import style0 from "./_Desembolsos.vue?vue&type=style&index=0&id=b4515a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4515a02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VMain,VPagination,VRow})
